import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Tab,
    Tabs,
    Typography,
    Switch,
    TableCell,
    TableBody,
    TableRow,
    TableHead,
    Table,
    TableContainer,
    MenuItem,
    Select,
    IconButton,
    SelectChangeEvent,
    Button
} from "@mui/material";
import SearchBar from "../../components/SearchBar";

import InfoIcon from '@mui/icons-material/Info';
import RejectReasonModal from "../../Modals/rejectReason";

import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ClearIcon from '@mui/icons-material/Clear';

import ReceiptIcon from '@mui/icons-material/Receipt';
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const ViewServiceProvider = () => {
    const navigate = useNavigate();
    const [valueTabs, setValueTabs] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };
    const [city, setCity] = useState("default");

    const handleChangeCity = (event: SelectChangeEvent) => {
        setCity(event.target.value as string);
    };
    const earningsColumns = [
        { id: "orderId", label: "Order ID" },
        { id: "customer", label: "Vendor Detail" },
        { id: "orderAmount", label: "Order Amount" },
        { id: "shippingCharge", label: "Shipping Charge" },
        { id: "commission", label: "Commission" },
        { id: "paymentMethod", label: "Payment Method" },
        { id: "orderDate", label: "Order Date" },
        { id: "status", label: "Status" }
    ];
    const bookingEarningsData = [
        {
            bookingId: "#BOOK_001",
            vendor: {
                name: "Aman Verma",
                phone: "9876501234"
            },
            amount: 4200,
            paymentMethod: "Online",
            bookingDate: "10 Oct 2025",
            status: "Completed"
        },
        {
            bookingId: "#BOOK_002",
            vendor: {
                name: "Rahul Mehta",
                phone: "9812345678"
            },
            amount: 2800,
            paymentMethod: "COD",
            bookingDate: "12 Oct 2025",
            status: "Pending"
        },
        {
            bookingId: "#BOOK_003",
            vendor: {
                name: "Priya Singh",
                phone: "9876000000"
            },
            amount: 3500,
            paymentMethod: "UPI",
            bookingDate: "14 Oct 2025",
            status: "Completed"
        }
    ];

    const reviews = [
        {
            id: 1,
            userName: "Alice Johnson",
            email: "alice.johnson@example.com",
            userImage: "/static/images/user_placeholder.png",
            orderId: "#Order_0001",
            rating: 5,
            review: "Excellent service and delivery! Very satisfied.",
            date: "25 July 2025",
        },
        {
            id: 2,
            userName: "Michael Smith",
            email: "michael.smith@example.com",
            userImage: "/static/images/user_placeholder.png",
            orderId: "#Order_0002",
            rating: 4,
            review: "Good experience overall, but delivery was a bit late.",
            date: "27 July 2025",
        },
        {
            id: 3,
            userName: "Priya Kapoor",
            email: "priya.kapoor@example.com",
            userImage: "/static/images/user_placeholder.png",
            orderId: "#Order_0003",
            rating: 3,
            review: "Average service. Product quality could be better.",
            date: "01 August 2025",
        },
        {
            id: 4,
            userName: "John Carter",
            email: "john.carter@example.com",
            userImage: "/static/images/user_placeholder.png",
            orderId: "#Order_0004",
            rating: 5,
            review: "Loved the experience! Fast and efficient.",
            date: "05 August 2025",
        },
        {
            id: 5,
            userName: "Sneha Mehta",
            email: "sneha.mehta@example.com",
            userImage: "/static/images/user_placeholder.png",
            orderId: "#Order_0005",
            rating: 2,
            review: "Not happy with the product. It was damaged.",
            date: "10 August 2025",
        },
    ];

    const [orderTab, setOrderTab] = useState(0);

    const tabLabels = [
        "All",
        "Pending",
        "Accepted",
        "Ongoing",
        "Completed",
        "Cancelled",
    ];

    const bookingData = [
        {
            bookingId: "#BOOK_001",
            vendorName: "Aman Verma",
            vendorPhone: "9876501234",
            dateTime: "02 August 2025, 09:30 AM",
            amount: "SAR 120.00",
            payment: "Card",
            category: "Electronics",
            service: "Service1",
            status: "Pending",
        },
        {
            bookingId: "#BOOK_002",
            vendorName: "Rahul Mehta",
            vendorPhone: "9812345678",
            dateTime: "03 August 2025, 12:15 PM",
            amount: "SAR 250.00",
            payment: "Cash on Delivery",
            category: "Clothing",
            service: "Service2",
            status: "Accept",
        },
        {
            bookingId: "#BOOK_003",
            vendorName: "Priya Singh",
            vendorPhone: "9876000000",
            dateTime: "04 August 2025, 01:45 PM",
            amount: "SAR 500.00",
            payment: "Release",
            category: "Accessories",
            service: "Service3",
            status: "Ongoing",
        },
        {
            bookingId: "#BOOK_004",
            vendorName: "Alice Johnson",
            vendorPhone: "9876543210",
            dateTime: "02 August 2025, 03:30 PM",
            amount: "SAR 199.99",
            payment: "Pending",
            category: "Clothing",
            service: "Service4",
            status: "Completed",
        },
        {
            bookingId: "#BOOK_005",
            vendorName: "Ravi Sharma",
            vendorPhone: "9821012345",
            dateTime: "05 August 2025, 10:45 AM",
            amount: "SAR 299.50",
            payment: "Escrow",
            category: "Electronics",
            service: "Service5",
            status: "Cancelled",
        },
    ];


    const services = [
        {
            id: "#SERV-001",
            name: "House Cleaning",
            category: "Home Services",
            subCategory: "Cleaning",
            price: 25,
            priceUnit: "hourly",
            duration: "2 hours",
            status: "Active",
            bookings: 150,
        },
        {
            id: "#SERV-002",
            name: "AC Repair",
            category: "Appliance Repair",
            subCategory: "Air Conditioner",
            price: 100,
            priceUnit: "fixed",
            duration: "N/A",
            status: "Inactive",
            bookings: 45,
        },
        {
            id: "#SERV-003",
            name: "Personal Training",
            category: "Health & Fitness",
            subCategory: "Fitness",
            price: 300,
            priceUnit: "package",
            duration: "1 Month",
            status: "Inactive",
            bookings: 30,
        },
    ];
    const offersData = [
        {
            offerName: "Diwali Offer",
            couponCode: "DIWALI10",
            discountType: "Percentage",
            discountValue: "10%",
            applicableOn: "Service 1, Category 2",
            validFrom: "25 August 2025",
            validTo: "30 August 2025",
            createdDate: "30 July 2025",
        },
        {
            offerName: "New Year Blast",
            couponCode: "NEWYEAR25",
            discountType: "Percentage",
            discountValue: "25%",
            applicableOn: "Service 2, Category 1",
            validFrom: "01 January 2026",
            validTo: "05 January 2026",
            createdDate: "20 December 2025",
        },
        {
            offerName: "Weekend Saver",
            couponCode: "WEEKEND50",
            discountType: "Flat",
            discountValue: "50 AED",
            applicableOn: "Service 1, Service 2",
            validFrom: "10 March 2026",
            validTo: "12 March 2026",
            createdDate: "01 March 2026",
        },
        {
            offerName: "Ramadan Special",
            couponCode: "RAMADAN15",
            discountType: "Percentage",
            discountValue: "15%",
            applicableOn: "Category 1, Category 2",
            validFrom: "15 April 2026",
            validTo: "15 May 2026",
            createdDate: "01 April 2026",
        },
        {
            offerName: "Flash Hour Deal",
            couponCode: "FLASH99",
            discountType: "Flat",
            discountValue: "99 AED",
            applicableOn: "Service 2",
            validFrom: "18 June 2026",
            validTo: "19 June 2026",
            createdDate: "16 June 2026",
        },
        {
            offerName: "Mega Summer Sale",
            couponCode: "SUMMER30",
            discountType: "Percentage",
            discountValue: "30%",
            applicableOn: "Service 1, Category 1, Category 2",
            validFrom: "01 July 2026",
            validTo: "10 July 2026",
            createdDate: "25 June 2026",
        },
        {
            offerName: "Black Friday Max",
            couponCode: "BLACKFRIDAY70",
            discountType: "Percentage",
            discountValue: "70%",
            applicableOn: "Service 2, Category 2",
            validFrom: "29 November 2026",
            validTo: "30 November 2026",
            createdDate: "01 November 2026",
        },
    ];

    // Filter services by search term (case-insensitive search by name)
    const filteredServices = services.filter((service) =>
        service.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const [open1, setOpen1] = useState(false);
    const handleCloseModal1 = () => {
        setOpen1(false);
    };
    return (
        <>
            <div className="main_title">
                <h1>View Service Provider</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/manage-service-providers")}>
                        Manage Service Providers
                    </button>{" "}
                    - View Service Provider
                </p>
            </div>
            <div className="cards">
                <div className="gap_p view_page">
                    {/* Owner Name */}
                    <div className="w_33">
                        <h6>Owner Name</h6>
                        <p>Arjun Mehta</p>
                    </div>

                    {/* Email */}
                    <div className="w_33">
                        <h6>Email</h6>
                        <p>arjun.mehta@example.com</p>
                    </div>

                    {/* Contact Phone */}
                    <div className="w_33">
                        <h6>Contact Phone</h6>
                        <p>+91 98765 43210</p>
                    </div>

                </div>
            </div>
            <Box className="custom_tabs1">
                <Tabs
                    value={valueTabs}
                    onChange={handleChangeTabs}
                    className="custom_tabs_links"
                >
                    <Tab label="Review Profile" {...a11yProps(0)} />
                    <Tab label="Personal Details" {...a11yProps(1)} />
                    <Tab label="Documents" {...a11yProps(2)} />
                    <Tab label="Earnings" {...a11yProps(3)} />
                    <Tab label="Reviews" {...a11yProps(4)} />
                    <Tab label="Services" {...a11yProps(5)} />
                    <Tab label="Booking History" {...a11yProps(6)} />
                    <Tab label="Discount & Coupons" {...a11yProps(7)} />
                </Tabs>
            </Box>
            <div className="cards view_page">
                <CustomTabPanel value={valueTabs} index={0}>
                    <div className="wrap_viewDemo_steps">
                        <div className="form">
                            <div className="gap_p">
                                <div className="control_group w_100">
                                    <div className="border_box">
                                        <label htmlFor="display_email">Email </label>
                                        <p id="display_email">johndoe@yopmail.com</p>
                                    </div>
                                </div>
                                <div className="control_group w_50">
                                    <div className="border_box">
                                        <label htmlFor="display_tl">Uploaded Trade License </label>
                                        <div id="display_tl" className="doc_preview">
                                            <ImageOutlinedIcon /> <p>trade-license.jpg</p> <IconButton className='btn_rounded primary'><FileDownloadOutlinedIcon /></IconButton>
                                        </div>
                                    </div>
                                </div>
                                <div className="control_group w_50">
                                    <div className="border_box">
                                        <label htmlFor="display_moa">Upload Memorandum of Association (MOA) </label>
                                        <div id="display_moa" className="doc_preview">
                                            <ImageOutlinedIcon /> <p>memorandum-of-association.jpg</p> <IconButton className='btn_rounded primary'><FileDownloadOutlinedIcon /></IconButton>
                                        </div>
                                    </div>
                                </div>
                                <div className="control_group w_100">
                                    <div className="border_box">
                                        <label htmlFor="display_about">Tell us about your business </label>
                                        <p id="display_about">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Animi minima quis labore eveniet dolor deserunt veritatis necessitatibus maiores natus nulla.</p>
                                    </div>
                                </div>
                                <div className="control_group w_100">
                                    <div className="border_box">
                                        <label htmlFor="display_images">Uploaded Sample Product Images </label>
                                        <div id="display_images" className="uploaded_images" style={{ marginTop: "10px" }}>
                                            <div className="inner gap_m">
                                                <figure><img src="/static/images/placeholder.png" alt='sample product' /> <IconButton className="btn_rounded"><ClearIcon /></IconButton></figure>
                                                <figure><img src="/static/images/placeholder.png" alt='sample product' /> <IconButton className="btn_rounded"><ClearIcon /></IconButton></figure>
                                                <figure><img src="/static/images/placeholder.png" alt='sample product' /> <IconButton className="btn_rounded"><ClearIcon /></IconButton></figure>
                                                <figure><img src="/static/images/placeholder.png" alt='sample product' /> <IconButton className="btn_rounded"><ClearIcon /></IconButton></figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="control_group w_100">
                                    <div className="border_box">
                                        <label htmlFor="display_video">Product Video </label>
                                        <p id="display_video"><a href="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4">https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4</a></p>
                                    </div>
                                </div>
                                <div className="control_group w_100">
                                    <div className="border_box">
                                        <label htmlFor="display_social">Social Media Links </label>
                                        <ul id="display_social" className="social_list">
                                            <li>
                                                <IconButton className='btn_rounded primary'><img src="/static/images/twitter_icon.svg" alt="twitter" /></IconButton>
                                                <p><a href="https://www.facebook.com/">https://www.facebook.com/</a></p>
                                            </li>
                                            <li>
                                                <IconButton className='btn_rounded primary'><img src="/static/images/facebook_icon.svg" alt="facebook" /></IconButton>
                                                <p><a href="https://www.twitter.com/">https://twitter.com/</a></p>
                                            </li>
                                            <li>
                                                <IconButton className='btn_rounded primary'><img src="/static/images/instagram_icon.svg" alt="instagram" /></IconButton>
                                                <p><a href="https://www.instagram.com/">https://www.instagram.com/</a></p>
                                            </li>
                                            <li>
                                                <img className="tick_tok" src="/static/images/ticktok_icon.svg" alt="tiktok" />
                                                <p><a href="https://www.tiktok.com/">https://www.tiktok.com/</a></p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="form_btn">
                                <Button className="btn btn_primary">Accept</Button>
                                <Button className="btn btn_grey" onClick={() => setOpen1(true)}>Reject</Button>
                            </div>
                        </div>
                    </div>
                </CustomTabPanel>
                {/* Personal Details Tab */}
                <CustomTabPanel value={valueTabs} index={1}>
                    <div className="gap_p">

                        {/* Logo */}
                        <div className="vew_img no_radius w_100">
                            <h6>Image</h6>
                            <figure>
                                <img src="/static/images/placeholder.png" alt="logo" />
                            </figure>
                        </div>

                        {/* ID, Owner Name, Store Name */}
                        <div className="w_33">
                            <h6>ID</h6>
                            <p>#SP_001</p>
                        </div>
                        <div className="w_33">
                            <h6>Owner name</h6>
                            <p>Rajesh Kumar</p>
                        </div>
                        <div className="w_33">
                            <h6>Store name</h6>
                            <p>Kumar General Store</p>
                        </div>

                        {/* Email, Phone */}
                        <div className="w_33">
                            <h6>Contact Email</h6>
                            <p>contact@kumarstore.com</p>
                        </div>
                        <div className="w_33">
                            <h6>Contact Phone</h6>
                            <p>+91 9876543210</p>
                        </div>

                        {/* Opening and Closing Time */}
                        <div className="w_33">
                            <h6>Store Opening Time</h6>
                            <p>05:00 am</p>
                        </div>
                        <div className="w_33">
                            <h6>Store Closing Time</h6>
                            <p>05:00 pm</p>
                        </div>

                        {/* Onboard Date & Status */}
                        <div className="w_33">
                            <h6>Onboard Date</h6>
                            <p>30 July 2025</p>
                        </div>
                        <div className="w_33">
                            <h6>Status</h6>
                            <Switch defaultChecked inputProps={{ 'aria-label': 'Status' }} />
                        </div>

                        {/* Bio */}
                        <div className="w_100">
                            <h6>Bio</h6>
                            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iste similique quidem perspiciatis odit provident! Excepturi?</p>
                        </div>

                        {/* Address Section */}
                        <div className="title_inner">
                            <h2>Address Details</h2>
                        </div>
                        <div className="w_100">
                            <h6>Address</h6>
                            <p>
                                C-127, Phase-8, Industrial Area, Sector 73, Sahibzada Ajit Singh Nagar, Punjab 160071
                            </p>
                        </div>

                        {/* Bank Section */}
                        <div className="title_inner">
                            <h2>Bank Details</h2>
                        </div>
                        <div className="w_33">
                            <h6>Account Holder Name</h6>
                            <p>Alice</p>
                        </div>
                        <div className="w_33">
                            <h6>Bank Account Number</h6>
                            <p>218978124</p>
                        </div>
                        <div className="w_33">
                            <h6>Bank Name</h6>
                            <p>PNB</p>
                        </div>
                        <div className="w_33">
                            <h6>Bank Branch Code</h6>
                            <p>6228</p>
                        </div>
                    </div>
                </CustomTabPanel>

                {/* Other Tabs - Placeholder Content */}
                <CustomTabPanel value={valueTabs} index={2}>
                    <div className="gap_p">

                        {/* Logo */}

                        {/* ID, Owner Name, Store Name */}
                        <div className="w_50">
                            <h6>Document Name</h6>
                            <p>Doc1</p>
                        </div>
                        <div className="w_50">
                            <h6>Expiry date</h6>
                            <p>22-02025</p>
                        </div>
                        <div className="vew_img v2 no_radius w_50">
                            <h6>Front Image</h6>
                            <figure>
                                <img src="/static/images/placeholder.png" alt="logo" />
                            </figure>
                        </div>
                        <div className="vew_img v2 no_radius w_50">
                            <h6>Back Image</h6>
                            <figure>
                                <img src="/static/images/placeholder.png" alt="logo" />
                            </figure>
                        </div>

                    </div>
                </CustomTabPanel>

                <CustomTabPanel value={valueTabs} index={3}>
                    <div className="gap_p">

                        {/* Total Earnings */}
                        <div className="total_summary">
                            <h6>Total Earnings</h6>
                            <p>AED 5000</p>
                        </div>

                        {/* Booking Earnings Table */}
                        <TableContainer className="table_container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Booking ID</TableCell>
                                        <TableCell>Vendor Details</TableCell>
                                        <TableCell>Booking Amount</TableCell>
                                        <TableCell>Payment Method</TableCell>
                                        <TableCell>Booking Date</TableCell>
                                        <TableCell>Status</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {bookingEarningsData.map((row, index) => (
                                        <TableRow key={index} hover>
                                            <TableCell>{row.bookingId}</TableCell>

                                            <TableCell>
                                                <div className="user_block">
                                                    <figure>
                                                        <img
                                                            src="/static/images/user_placeholder.png"
                                                            alt="Vendor"
                                                        />
                                                    </figure>
                                                    <p>
                                                        <b>{row.vendor.name}</b>
                                                        {row.vendor.phone}
                                                    </p>
                                                </div>
                                            </TableCell>

                                            <TableCell>
                                                ₹ {row.amount.toLocaleString()}
                                            </TableCell>

                                            <TableCell>{row.paymentMethod}</TableCell>

                                            <TableCell>{row.bookingDate}</TableCell>

                                            <TableCell>
                                                <span className={`status ${row.status.toLowerCase()}`}>
                                                    {row.status}
                                                </span>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </CustomTabPanel>


                <CustomTabPanel value={valueTabs} index={4}>

                    <div className="table_header">
                        <div className="left_s">
                            <Box className="search_box">
                                <SearchBar
                                    searchTerm={searchTerm}
                                    setDebouncedSearchTerm={setSearchTerm}
                                    placeholder="Search..."
                                />
                            </Box>
                        </div>
                    </div>

                    <TableContainer className="table_container">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Sr. No</TableCell>
                                    <TableCell>Vendor Details</TableCell>
                                    <TableCell>Order ID</TableCell>
                                    <TableCell>Rating</TableCell>
                                    <TableCell>Review</TableCell>
                                    <TableCell>Date</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {reviews.map((item, index) => (
                                    <TableRow key={item.id} hover>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>
                                            <div className="user_block">
                                                <figure>
                                                    <img
                                                        src={item.userImage || "/static/images/user_placeholder.png"}
                                                        alt="User"
                                                    />
                                                </figure>
                                                <p>
                                                    <b>{item.userName}</b>

                                                    {item.email}
                                                </p>
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <strong>{item.orderId}</strong>
                                        </TableCell>
                                        <TableCell>

                                            {item.rating} Star

                                        </TableCell>
                                        <TableCell className="max_c2">
                                            <p>{item.review}</p>
                                        </TableCell>
                                        <TableCell>{item.date}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>


                </CustomTabPanel>

                <CustomTabPanel value={valueTabs} index={5}>
                    <div className="table_header">
                        <div className="left_s">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search by service name..."
                            />
                        </div>

                    </div>

                    <TableContainer className="table_container" sx={{ mt: 3 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Sr. No</TableCell>
                                    <TableCell>Service Name</TableCell>
                                    <TableCell>Category</TableCell>
                                    <TableCell>Sub-category</TableCell>
                                    <TableCell>Price</TableCell>
                                    <TableCell>Duration</TableCell>
                                    <TableCell>Number of Bookings</TableCell>
                                    <TableCell>Service Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredServices.map((service, index) => (
                                    <TableRow key={service.id} hover>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{service.name}</TableCell>
                                        <TableCell>{service.category}</TableCell>
                                        <TableCell>{service.subCategory}</TableCell>
                                        <TableCell>
                                            {service.price} {service.priceUnit}
                                        </TableCell>
                                        <TableCell>{service.duration}</TableCell>

                                        <TableCell>{service.bookings}</TableCell>
                                        <TableCell>{service.status}</TableCell>


                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CustomTabPanel>

                <CustomTabPanel value={valueTabs} index={6}>
                    <Box className="custom_tabs1">
                        <Tabs
                            value={orderTab}
                            onChange={(e, newValue) => setOrderTab(newValue)}
                            className="custom_tabs_links"
                        >
                            <Tab label="All" {...a11yProps(0)} />
                            <Tab label="Pending" {...a11yProps(1)} />
                            <Tab label="Accepted" {...a11yProps(2)} />
                            <Tab label="Ongoing" {...a11yProps(3)} />
                            <Tab label="Completed" {...a11yProps(4)} />
                            <Tab label="Cancelled" {...a11yProps(5)} />
                        </Tabs>
                    </Box>

                    {[0, 1, 2, 3, 4, 5].map((tabIndex) => (
                        <CustomTabPanel key={tabIndex} value={orderTab} index={tabIndex}>
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search..."
                                        />
                                    </Box>
                                </div>
                                <div className="right_s"></div>
                            </div>
                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Booking ID</TableCell>
                                            <TableCell>Vendor Detail</TableCell>
                                            <TableCell>Booking Date/Time</TableCell>
                                            <TableCell>Amount</TableCell>
                                            <TableCell>Payment</TableCell>
                                            <TableCell>Category Name</TableCell>
                                            <TableCell>Service Name</TableCell>
                                            <TableCell>Status</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {bookingData.map((item, index) => (
                                            <TableRow key={index} hover>
                                                <TableCell>{item.bookingId}</TableCell>

                                                <TableCell>
                                                    <div className="vendor_cell">
                                                        <div className="avatar" />
                                                        <div>
                                                            <p className="name">{item.vendorName}</p>
                                                            <p className="phone">{item.vendorPhone}</p>
                                                        </div>
                                                    </div>
                                                </TableCell>

                                                <TableCell>{item.dateTime}</TableCell>
                                                <TableCell>{item.amount}</TableCell>
                                                <TableCell>{item.payment}</TableCell>
                                                <TableCell>{item.category}</TableCell>
                                                <TableCell>{item.service}</TableCell>

                                                <TableCell>
                                                    {item.status}
                                                </TableCell>


                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </CustomTabPanel>
                    ))}
                </CustomTabPanel>
                <CustomTabPanel value={valueTabs} index={7}>
                    <div className="table_header">
                        <div className="left_s">
                            <Box className="search_box">
                                <SearchBar
                                    searchTerm={searchTerm}
                                    setDebouncedSearchTerm={setSearchTerm}
                                    placeholder="Search..."
                                />
                            </Box>
                        </div>
                        <div className="right_s"></div>
                    </div>
                    <TableContainer className="table_container">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Sr. No</TableCell>
                                    <TableCell>Offer / Discount Name</TableCell>
                                    <TableCell>Coupon Code</TableCell>
                                    <TableCell>Discount Type</TableCell>
                                    <TableCell>Discount Value</TableCell>
                                    <TableCell>Applicable Services / Categories</TableCell>
                                    <TableCell>Valid From – To</TableCell>
                                    <TableCell>Created Date</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {offersData.map((item, index) => (
                                    <TableRow key={index} hover>
                                        <TableCell>{index + 1}</TableCell>

                                        <TableCell>{item.offerName}</TableCell>

                                        <TableCell>
                                            <span className="coupon_badge">{item.couponCode}</span>
                                        </TableCell>

                                        <TableCell>{item.discountType}</TableCell>

                                        <TableCell>{item.discountValue}</TableCell>

                                        <TableCell>{item.applicableOn}</TableCell>

                                        <TableCell>
                                            {item.validFrom} – {item.validTo}
                                        </TableCell>

                                        <TableCell>{item.createdDate}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                </CustomTabPanel>
            </div>
            <RejectReasonModal open={open1} onClose={handleCloseModal1} setOpen={setOpen1} />

        </>
    );
};

export default ViewServiceProvider;
